export const fields = {
  isCurrentSLAAvaliable: {
    label: "Does client have a current SLA?",
    value: null,
    observers: [
      {
        key: "value",
        call: ({ form, field }) => {
          let isHistoricSLAAvaliable = form.$("isHistoricSLAAvaliable");
          let SLAExpiredDate = form.$("slaExpiryDate");
          if (field.value === true || field.value === "true") {
            SLAExpiredDate.set("disabled", false);
            isHistoricSLAAvaliable.clear();
          } else {
            SLAExpiredDate.clear();
            SLAExpiredDate.set("disabled", true);
          }
        },
      },
    ],
  },
  isHistoricSLAAvaliable: {
    label: "Does client have a historic SLA?",
    value: null,
    observers: [
      {
        key: "value",
        call: ({ form, field }) => {
          if (field.value) {
            let SLAExpiredDate = form.$("slaExpiryDate");
            SLAExpiredDate.set("disabled", !(field.value === "Yes"));
            SLAExpiredDate.clear();
          }
        },
      },
    ],
  },
  slaExpiryDate: {
    label: "SLA Expiry Date",
    disabled: true,
    rules: "required",
    value: null,
    defaultValue: null,
  },
  slaStatusID: {
    label: "SLA Status",
    value: null,
  },
  slaReminderDate: {
    label: "Reminder Date",
    value: null,
  },
  slaRecipient: {
    label: "Reminder to be sent to",
    value: null,
  },
};
